const elems = {
  first_name: {
    name: "first_name",
    label: "Prénom",
    component: "Input",
    autocomplete: "given-name",
    canSaveTo: ["first_name", "Input"],
  },
  last_name: {
    name: "last_name",
    label: "Nom",
    component: "Input",
    autocomplete: "family-name",
    canSaveTo: ["last_name", "Input"],
  },
  full_name: {
    name: "full_name",
    label: "Nom complet",
    component: "Input",
    autocomplete: "name",
    canSaveTo: ["full_name", "Input"],
  },
  ean: {
    name: "ean",
    label: "EAN",
    component: "Input",
    validation: "numeric|length:13",
    canSaveTo: ["ean", "Input"],
  },
  siret: {
    name: "siret",
    label: "Siret",
    component: "Input",
    validation: "numeric|length:14",
    unique: false,
    canSaveTo: ["siret", "Input"],
  },
  siren: {
    name: "siren",
    label: "Siren",
    component: "Input",
    validation: "numeric|length:9",
    unique: false,
    canSaveTo: ["siren", "Input"],
  },
  bic: {
    name: "bic",
    label: "BIC",
    component: "Input",
    validation: "",
    canSaveTo: ["bic", "Input"],
  },
  email: {
    name: "email",
    label: "Email",
    component: "Input",
    type: "email",
    confirmation: false,
    confirmationLabel: "Confirmez votre email",
    unique: false,
    autocomplete: "email",
    blockTempEmailProviders: true,
    blockEmailWithPlus: true,
    canSaveTo: ["email", "Input"],
  },
  input_text: {
    name: "input_text",
    label: "Champ texte",
    component: "Input",
    validation: "",
    regex: "",
    canSaveTo: ["Input"],
  },
  textarea: {
    name: "textarea",
    label: "Zone de texte",
    component: "Textarea",
    validation: "",
    regex: "",
    row: 5,
    col: 33,
    canSaveTo: ["Input"],
  },
  input_number: {
    name: "input_number",
    label: "Nombre",
    component: "InputNumber",
    validation: "",
    regex: "",
    canSaveTo: ["InputNumber"],
  },
  iban: {
    name: "iban",
    label: "Iban",
    component: "Iban",
    unique: false,
    canSaveTo: ["Iban", "Input"],
  },
  securite_sociale_fr: {
    name: "securite_sociale_fr",
    label: "N. Sécurité sociale",
    component: "SecuriteSociale",
    unique: false,
    canSaveTo: ["SecuriteSocialeFr", "Input"],
  },
  customer_exp_metric: {
    name: "customer_exp_metric",
    label: "Evaluation",
    component: "CustomerExpMetric",
    numberOfItem: 10,
    numberOfGreenItem: 2,
    numberOfRedItem: 6,
    hint10: "Oui, tout à fait",
    hint0: "Pas du tout",
    canSaveTo: ["nps", "cex", "InputNumber"],
  },
  date: {
    name: "date",
    label: "Date",
    component: "DateInput",
    dateMaxToday: false,
    min: undefined,
    max: undefined,
    isBirthDate: false,
    canSaveTo: ["Date"],
  },
  gender: {
    name: "gender",
    label: "Civilité",
    component: "Civilite",
    type: "select", // in ['select', 'radio']
    LabelMadame: "Madame",
    LabelMonsieur: "Monsieur",
    canSaveTo: ["Civilite", "Input"],
  },
  file: {
    //
    name: "file",
    label: "Envois de fichier",
    component: "File",
    isButtonUpload: false,
    buttonUploadLabel: "",
    sizeMax: 50000,
    canSaveTo: ["File"],
    accept: ".pdf,image/*",
  },
  address: {
    name: "file",
    label: "Adresse",
    component: "Adresse",
    countries: ["fr"],
    canSaveTo: ["Adresse"],
    configuration: {
      displayFieldsAfterSelection: false,
    },
  },
  postal_code: {
    // todo create special component
    name: "postal_code",
    label: "Code postal",
    component: "Input",
    //country: 'fr',
    validation: "numeric|length:5",
    canSaveTo: ["PostalCode", "Input"],
  },
  checkbox: {
    name: "checkbox",
    label: "Case à cocher",
    component: "Checkbox",
    canSaveTo: ["Checkbox"],
  },
  select: {
    name: "select",
    label: "Select",
    component: "Select",
    defaultOptionText: "",
    options: [
      {
        value: "value",
        name: "value",
        other: false,
      },
    ],
    canSaveTo: ["Input"],
  },
  produits: {
    name: "select",
    label: "Produits",
    component: "Select",
    defaultOptionText: "",
    options: [
      {
        value: "value",
        name: "value",
        other: false,
      },
    ],
    canSaveTo: ["Input"],
  },
  pointsdeventes: {
    name: "select",
    label: "Points de vente",
    component: "Select",
    defaultOptionText: "",
    options: [
      {
        value: "value",
        name: "value",
        other: false,
      },
    ],
    canSaveTo: ["Input"],
  },
  enseignes: {
    name: "select",
    label: "Enseignes",
    component: "Select",
    defaultOptionText: "",
    save_to: "enseigne",
    options: [
      {
        value: "value",
        name: "value",
        other: false,
      },
    ],
    canSaveTo: ["Input"],
  },
  select_multiple: {
    name: "select_multiple",
    label: "Select Multiple",
    component: "MultiSelect",
    searchable: false,
    closeOnSelect: true,
    multiple: true,
    limit: 0,
    options: [
      {
        value: "value",
        name: "name",
      },
    ],
    canSaveTo: ["Input"],
  },
  radio: {
    name: "radio",
    label: "Bouton Radio",
    component: "Radio",
    options: [
      {
        value: "value",
        name: "value",
      },
    ],
    canSaveTo: ["Input"],
  },
  departements: {
    name: "departements",
    label: "Département",
    component: "Select",
    defaultOptionText: "",
    options: [
      { value: "01", name: "01 - Ain" },
      { value: "02", name: "02 - Aisne" },
      { value: "03", name: "03 - Allier" },
      { value: "04", name: "04 - Alpes-de-Haute-Provence" },
      { value: "05", name: "05 - Hautes-Alpes" },
      { value: "06", name: "06 - Alpes-Maritimes" },
      { value: "07", name: "07 - Ardèche" },
      { value: "08", name: "08 - Ardennes" },
      { value: "09", name: "09 - Ariège" },
      { value: "10", name: "10 - Aube" },
      { value: "11", name: "11 - Aude" },
      { value: "12", name: "12 - Aveyron" },
      { value: "13", name: "13 - Bouches-du-Rhône" },
      { value: "14", name: "14 - Calvados" },
      { value: "15", name: "15 - Cantal" },
      { value: "16", name: "16 - Charente" },
      { value: "17", name: "17 - Charente-Maritime" },
      { value: "18", name: "18 - Cher" },
      { value: "19", name: "19 - Corrèze" },
      { value: "2A", name: "2A - Corse du sud" },
      { value: "2B", name: "2B - Corse du nord" },
      { value: "21", name: "21 - Côte-d'or" },
      { value: "22", name: "22 - Côtes-d'armor" },
      { value: "23", name: "23 - Creuse" },
      { value: "24", name: "24 - Dordogne" },
      { value: "25", name: "25 - Doubs" },
      { value: "26", name: "26 - Drôme" },
      { value: "27", name: "27 - Eure" },
      { value: "28", name: "28 - Eure-et-Loir" },
      { value: "29", name: "29 - Finistère" },
      { value: "30", name: "30 - Gard" },
      { value: "31", name: "31 - Haute-Garonne" },
      { value: "32", name: "32 - Gers" },
      { value: "33", name: "33 - Gironde" },
      { value: "34", name: "34 - Hérault" },
      { value: "35", name: "35 - Ille-et-Vilaine" },
      { value: "36", name: "36 - Indre" },
      { value: "37", name: "37 - Indre-et-Loire" },
      { value: "38", name: "38 - Isère" },
      { value: "39", name: "39 - Jura" },
      { value: "40", name: "40 - Landes" },
      { value: "41", name: "41 - Loir-et-Cher" },
      { value: "42", name: "42 - Loire" },
      { value: "43", name: "43 - Haute-Loire" },
      { value: "44", name: "44 - Loire-Atlantique" },
      { value: "45", name: "45 - Loiret" },
      { value: "46", name: "46 - Lot" },
      { value: "47", name: "47 - Lot-et-Garonne" },
      { value: "48", name: "48 - Lozère" },
      { value: "49", name: "49 - Maine-et-Loire" },
      { value: "50", name: "50 - Manche" },
      { value: "51", name: "51 - Marne" },
      { value: "52", name: "52 - Haute-Marne" },
      { value: "53", name: "53 - Mayenne" },
      { value: "54", name: "54 - Meurthe-et-Moselle" },
      { value: "55", name: "55 - Meuse" },
      { value: "56", name: "56 - Morbihan" },
      { value: "57", name: "57 - Moselle" },
      { value: "58", name: "58 - Nièvre" },
      { value: "59", name: "59 - Nord" },
      { value: "60", name: "60 - Oise" },
      { value: "61", name: "61 - Orne" },
      { value: "62", name: "62 - Pas-de-Calais" },
      { value: "63", name: "63 - Puy-de-Dôme" },
      { value: "64", name: "64 - Pyrénées-Atlantiques" },
      { value: "65", name: "65 - Hautes-Pyrénées" },
      { value: "66", name: "66 - Pyrénées-Orientales" },
      { value: "67", name: "67 - Bas-Rhin" },
      { value: "68", name: "68 - Haut-Rhin" },
      { value: "69", name: "69 - Rhône" },
      { value: "70", name: "70 - Haute-Saône" },
      { value: "71", name: "71 - Saône-et-Loire" },
      { value: "72", name: "72 - Sarthe" },
      { value: "73", name: "73 - Savoie" },
      { value: "74", name: "74 - Haute-Savoie" },
      { value: "75", name: "75 - Paris" },
      { value: "76", name: "76 - Seine-Maritime" },
      { value: "77", name: "77 - Seine-et-Marne" },
      { value: "78", name: "78 - Yvelines" },
      { value: "79", name: "79 - Deux-Sèvres" },
      { value: "80", name: "80 - Somme" },
      { value: "81", name: "81 - Tarn" },
      { value: "82", name: "82 - Tarn-et-Garonne" },
      { value: "83", name: "83 - Var" },
      { value: "84", name: "84 - Vaucluse" },
      { value: "85", name: "85 - Vendée" },
      { value: "86", name: "86 - Vienne" },
      { value: "87", name: "87 - Haute-Vienne" },
      { value: "88", name: "88 - Vosges" },
      { value: "89", name: "89 - Yonne" },
      { value: "90", name: "90 - Territoire de Belfort" },
      { value: "91", name: "91 - Essonne" },
      { value: "92", name: "92 - Hauts-de-Seine" },
      { value: "93", name: "93 - Seine-Saint-Denis" },
      { value: "94", name: "94 - Val-de-Marne" },
      { value: "95", name: "95 - Val-d'oise" },
    ],
    canSaveTo: ["Input"],
  },
  prix_produits: {
    name: "Select",
    label: "Prix Produits",
    component: "PrixProduits",
    defaultOptionText: "",
    configuration: {
      labelRef: "",
      displayDescription: false,
      labelDescription: "",
      labelQuantite: 0,
      labelPrix: "",
      displayQuantite: true,
      displayPrix: true,
    },
    options: [
      {
        value: "value",
        name: "value",
        other: false,
      },
    ],
    canSaveTo: ["Input"],
    save_to: "prix_produits",
  },
  phone: {
    name: "phone",
    label: "Téléphone",
    component: "Phone",
    phoneType: "both", // ['both', 'fixed', 'mobile']
    autocomplete: true,
    defaultCountry: "FR",
    acceptedCountries: ["FR"],
    canSaveTo: ["Phone", "Input"],
  },
  bloc_html: {
    name: "BlocHTML",
    label: "Bloc HTML",
    component: "BlocHTML",
    html: "<p>JoliBloc avec VUE syntaxe <br> xXx</p>",
  },
  bloc_html_simple: {
    label: "Bloc HTML simple",
    name: "BlocHTMLsimple",
    component: "BlocHTMLsimple",
    html: "<p>JoliBloc <br> xXx</p>",
  },
  multiple_files: {
    label: "Multi Upload",
    name: "MultipleFiles",
    component: "MultipleFiles",
    sizeMax: 10000,
    accept: ".pdf,image/*",
    canSaveTo: ["MultipleFiles"],
  },
  api_field: {
    name: "api_field",
    label: "Champ API",
    component: "ApiField",
    canSaveTo: [
      "Input",
      "first_name",
      "last_name",
      "full_name",
      "ean",
      "siret",
      "siren",
      "bic",
      "email",
      "Input",
      "Iban",
      "Date",
      "Civilite",
      "Adresse",
      "PostalCode",
      "Phone",
      "Date",
    ],
  },
  recap: {
    name: "recap",
    label: "Recap",
    component: "Recap",
    canSaveTo: [
      "first_name",
      "last_name",
      "full_name",
      "ean",
      "siret",
      "siren",
      "bic",
      "email",
      "Input",
      "Iban",
      "Date",
      "Civilite",
      "Adresse",
      "PostalCode",
      "Phone",
      "Date",
      "motif_nc",
    ],
  },
};
export default elems;
/*
  
  ######
  component: 'PSAReparateur',
  
  ######
  component: 'BlocHTML', */
